/* eslint-disable import/no-unresolved */
import { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Autoplay, Pagination, Keyboard, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import StaticSplitWidthHeroBanner from '../../Banners/StaticSplitWidth';
import StaticHeroImageOverflow from '../../Banners/StaticHeroImageOverflow';
import Hero from '../../../Screens/Hero';
import OfferBannerHero from '../../Banners/OfferBannerHero';

import { HeroWrapper, StyledContainer } from './styles';

const breakpoints = {
  320: {
    slidesPerView: '1',
    spaceBetween: 0,
  },
};

const pageTemplate = {
  'static-full-width-content': Hero,
  'static-with-background-overflow': Hero,
  'static-split-width-content': StaticSplitWidthHeroBanner,
  'pcma-hero': StaticSplitWidthHeroBanner,
  'static-hero-image-overflow': StaticHeroImageOverflow,
  'offer-banner-hero': OfferBannerHero,
};

const heroSlideGenerator = (sections, template) => {
  const HeroSlides = sections.map(({ component }, index) => {
    if (!component) {
      console.warn(
        `HeroSlides builder - A component field is required on all content types to pass the data appropriately`,
      );
      return false;
    }
    const componentType = component.toLowerCase();
    const Component = template[componentType];
    if (Component) {
      return (
        <SwiperSlide key={sections[index].id}>
          <Component data={sections[index]} className="hero-carousel" />
        </SwiperSlide>
      );
    }
    console.warn(
      `HeroSlides builder - Didn't find a component to match the ${component} value`,
    );
    return false;
  });
  return <>{HeroSlides}</>;
};

const HeroCarousel = ({ data }) => {
  if (!data) return null;

  const { elements } = data;

  const heroBackgroundColor = useMemo(() => {
    return elements.map(hero => hero.backgroundColor);
  }, [elements]);

  const [bgColor, setBgColor] = useState(heroBackgroundColor[0]);

  const heroSlides = heroSlideGenerator(elements, pageTemplate);
  return (
    <StyledContainer
      backgroundColor={bgColor}
      className="hero-carousel-container"
    >
      <HeroWrapper $bgColor={bgColor}>
        <Swiper
          tabIndex="0"
          breakpoints={breakpoints}
          a11y={{
            slideRole: 'group',
            enabled: true,
          }}
          autoplay={{
            delay: 10000,
            disableOnInteraction: true,
          }}
          allowTouchMove
          keyboard
          pagination={{ clickable: true }}
          modules={[Autoplay, Pagination, Keyboard, A11y]}
          onSlideChange={swiperCore => {
            const { activeIndex } = swiperCore;
            setBgColor(heroBackgroundColor[activeIndex]);
          }}
        >
          {elements && <>{heroSlides}</>}
        </Swiper>
      </HeroWrapper>
    </StyledContainer>
  );
};

HeroCarousel.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default HeroCarousel;
